module.exports = __webpack_public_path__ + "img/banner-actus.a3918127.jpeg";